<template>
  <div class="week">
    <span v-if="week" class="weeknr">{{ date.format("YYYY-W") }}</span>

    <span v-if="week" style="display: flex; width: 100%">
      <DayCard
        v-for="wd in weekdays"
        :key="wd"
        :date="getDateForWeekday(wd)"
        :dayObject="week.days[wd]"
        @dayCardUpdated="onDayCardUpdated"
        ></DayCard>
    </span>

  </div>
</template>

<script>
import DayCard from '@/components/DayCard';
import moment from 'moment';
import { debounce } from 'debounce';


export default {
  name: "Week",
  props: ["date", "weekdays"],
  components: {
    DayCard
  },
  computed: {
    weekString() {
      return this.date.format("YYYY-W");
    },
    week() {
      let weekDoc = this.$store.getters["weeks/getWeekDoc"](this.weekString);
      if (weekDoc) {
        return weekDoc.data;
      } else {
        return null;
      }
    }
  },
  created() {
    // console.log(`Week.created ${this.weekString}`)
    this.$store.dispatch("weeks/fetchWeek", {weekString: this.weekString})
    // one debounce function per board instance!
    this.saveWeekDebounced = debounce(this.saveWeek, 3000);
  },
  methods: {
    getDateForWeekday(wd) {
      return moment(this.date).weekday(wd);
    },
    onDayCardUpdated(){
      // console.log(`Week.onDayCardUpdated ${this.date.format("YYYY-W")}`);
      this.saveWeekDebounced();
      this.$store.commit('weeks/updateToday');
    },

    saveWeek(){
      this.$store.dispatch('weeks/saveWeek', {weekString: this.weekString});
    },

  }
}
</script>

<style scoped>

.week {
  display: flex;
}

.weeknr {
  color: #aaa;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  margin: 2px;
  text-align: center;
}

</style>


